// @flow
import React, { Component } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Button, Text } from 'trpc-react-native-ui';

import theme from '../../../../theme-config';

type Props = {
  disabled: boolean,
  isActive: boolean,
  label: string,
  onSelect: Function,
  style: Object,
};

class RadioButton extends Component<Props> {
  styles = getStyles();

  viewStyle = () => {
    if (this.props.isActive) {
      return this.styles.selectedRadioButtonOuterRing;
    } else {
      return this.props.disabled ? this.styles.disabledRadioButtonOuterRing : this.styles.inactiveRadioButtonOuterRing;
    }
  };

  textStyle = () => {
    if (!this.props.isActive) {
      return this.props.disabled ? this.styles.disabledLabel : this.styles.inactiveLabel;
    }
  };

  render() {
    const { disabled, isActive, label, onSelect, style } = this.props;

    return (
      <Button 
        onPress={onSelect} 
        style={[this.styles.buttonContainer, style]} 
        disabled={disabled}
        transparent={Platform.OS === 'web'}
      >
        <View style={this.styles.row}>
          <View style={[this.styles.radioButtonOuterRing, this.viewStyle()]}>
            {isActive && <View style={this.styles.selectedRadioButton} />}
          </View>
          <Text style={[this.styles.label, this.textStyle()]}>{label}</Text>
        </View>
      </Button>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    buttonContainer: {
      marginRight: 20,
      backgroundColor: 'transparent',
      borderWidth: 0,
      padding: 0,
      ...Platform.select({
        web: {
          outlineStyle: 'none',
          boxShadow: 'none',
          cursor: 'pointer', 
        }
      })
    },
    label: {
      color: theme.signUpInputTextColor,
      fontSize: 16,
      marginHorizontal: 10,
      backgroundColor: 'transparent',
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: 'transparent',
    },
    radioButtonOuterRing: {
      width: 25,
      height: 25,
      borderWidth: 2,
      borderRadius: 50,
      borderColor: theme.signUpInputTextColor,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'transparent',
    },
    selectedRadioButtonOuterRing: {
      borderWidth: 3,
    },
    selectedRadioButton: {
      width: 14,
      height: 14,
      borderRadius: 7,
      backgroundColor: theme.signUpInputTextColor,
    },
    inactiveLabel: {
      color: theme.signUpTransparentInputTextColor,
    },
    inactiveRadioButtonOuterRing: {
      borderColor: theme.signUpTransparentInputTextColor,
    },
    disabledLabel: {
      color: theme.radioButton.disabled,
    },
    disabledRadioButtonOuterRing: {
      borderColor: theme.radioButton.disabled,
    },
  });

export default RadioButton;